import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Loader2, RefreshCw, Check } from "lucide-react";
import { toast } from "sonner";
import { base44 } from "@/api/base44Client";

export default function GoogleCalendarConnect() {
  const [syncing, setSyncing] = useState(false);

  const handleConnect = () => {
    toast.info('Kontakt administrator for å sette opp Google Calendar OAuth');
  };

  const handleSyncAll = async () => {
    setSyncing(true);
    try {
      const result = await base44.functions.syncAllTasksToCalendar();

      if (result.success) {
        toast.success(result.message);
      } else {
        toast.error('Synkronisering feilet: ' + (result.message || result.error));
      }
    } catch (error) {
      console.error('Error syncing:', error);
      toast.error('Feil: ' + error.message);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Card className="bg-white border-0 shadow-sm">
      <div className="h-2 bg-gradient-to-r from-blue-500 to-blue-600" />
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center flex-shrink-0">
              <Calendar className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-slate-900 mb-1">Google Calendar</h3>
              <p className="text-sm text-slate-600">Synkroniser oppgaver til kalenderen din</p>
            </div>
          </div>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex items-start gap-2 text-sm text-slate-600">
            <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
            <span>Automatisk synkronisering av oppgaver med forfallsdatoer</span>
          </div>
          <div className="flex items-start gap-2 text-sm text-slate-600">
            <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
            <span>Oppdateres når status eller dato endres</span>
          </div>
          <div className="flex items-start gap-2 text-sm text-slate-600">
            <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
            <span>Fargekoder basert på prioritet</span>
          </div>
        </div>

        <div className="flex gap-3">
          <Button
            onClick={handleConnect}
            className="flex-1 bg-blue-600 hover:bg-blue-700"
          >
            <Calendar className="w-4 h-4 mr-2" />
            Koble til Google Calendar
          </Button>
          
          <Button
            onClick={handleSyncAll}
            disabled={syncing}
            variant="outline"
          >
            {syncing ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Synkroniserer...
              </>
            ) : (
              <>
                <RefreshCw className="w-4 h-4 mr-2" />
                Synkroniser
              </>
            )}
          </Button>
        </div>

        <div className="mt-4 p-3 bg-blue-50 rounded-lg">
          <p className="text-xs text-blue-700">
            💡 Når tilkoblingen er satt opp, synkroniseres oppgaver automatisk når de opprettes eller oppdateres.
          </p>
        </div>
      </div>
    </Card>
  );
}